<script setup lang="ts">

import {FetchError} from "ofetch";

const store = useTrackingStore();
const toasts = useToastsStore();
const {isLookingNumber, isLoadingGuestTrackingSession, trackingSessions} = storeToRefs(store);

const registrationNumberValue = ref<string>('');
const isSearchDisabled = computed(() => registrationNumberValue.value.length <= 2 || isLookingNumber.value);

const { t } = useI18n();

const find = () => {
  store.startTracking(registrationNumberValue.value)
      .then(session => {
        if (!session) {
          toasts.addInfo(t('navbar.tracking.no_item_found'));
        }
      })
      .catch((error: FetchError) => {
        if (300 == error.statusCode) {
          toasts.addInfo(t('navbar.tracking.a_few_items_found'));

          return;
        }

        toasts.addError(t('error_occurred_try_later'));
        captureException(error);
      });
};
</script>

<template>
  <div
    v-if="isLoadingGuestTrackingSession"
    class="placeholder-glow"
  >
    <span
      class="spinner-border spinner-border-sm text-success d-none d-sm-block"
      aria-hidden="true"
    />

    <div class="row d-sm-none">
      <div class="col-12">
        <div class="tracking-session border rounded p-2 position-relative bg-body">
          <div class="row">
            <div class="col-5 ps-3">
              <div class="calling-order d-inline-block h1">
                <strong class="placeholder">1</strong>
              </div>
              <div>
                <div class="registration-number placeholder">
                  1111 AA-1
                </div>
              </div>
            </div>
            <div class="col-7 text-nowrap">
              <div>
                <div class="h4 d-inline-block">
                  <strong class="placeholder">Checkpoint</strong>
                </div>
              </div>
              <div class="placeholder w-75 mb-1">
                time
              </div>
              <div class="d-flex align-items-center h5 m-0 placeholder">
                enter time
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
  <div
    v-else-if="0 === trackingSessions.length"
    class="d-flex"
  >
    <input
      v-model="registrationNumberValue"
      type="search"
      class="form-control me-2"
      maxlength="10"
      :placeholder="t('navbar.tracking.find_placeholder')"
      :disabled="isLookingNumber"
      @keyup.enter="find"
    >
    <button
      type="button"
      class="btn btn-outline-secondary d-inline-flex align-items-center"
      :disabled="isSearchDisabled"
      @click="find"
    >
      <span
        v-if="isLookingNumber"
        class="spinner-border spinner-border-sm me-1"
        aria-hidden="true"
      />
      {{ t('navbar.tracking.find') }}
    </button>
  </div>
</template>
